import { scrollTo } from '../../utils/_scrollTo';

const setupPaypalExpressCheckout = () => {
	if (
		$('#paypal-express-checkout-button-1').length > 0 ||
		($('#paypal-express-checkout-button-2').length > 0 &&
			$('#totalforJS').length > 0 &&
			Number(
				$('#totalforJS')
					.html()
					.replace(/[^0-9\.]+/g, '')
			) > 0)
	) {
		var amount = Number(
				$('#totalforJS')
					.html()
					.replace(/[^0-9\.]+/g, '')
			),
			expressCheckoutPaymentData = {
				flow: 'checkout',
				intent: 'order',
				amount: amount,
				currency: 'USD',
				enableShippingAddress: true,
				shippingAddressEditable: true,
				offerCredit: false,
				locale: 'en_US',
				singleUse: true,
			},
			style = {
				layout: 'horizontal',
				color: 'silver', 
				shape: 'rect', 
				size: 'responsive', 
				height: 35,
				tagline: false,
			},
			responseFunction = function (payload) {
				try { $(document).trigger('triggerCheckoutInitiate'); } catch (e) {}
				var shoppingCartForm = $('#ShopCartForm');
				$(`<input type="hidden" name="nonce" value="${payload.nonce}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="billingFirstName" value="${payload.details.firstName}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="billingLastName" value="${payload.details.lastName}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="billingEmail" value="${payload.details.email}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="billingPhone" value="${payload.details.phone.split('-').join('')}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="billingAddress1" value="${payload.details.billingAddress.line1}" />`).appendTo(shoppingCartForm);
				if (payload.details.billingAddress.line2)
					$(`<input type="hidden" name="billingAddress2" value="${payload.details.billingAddress.line2}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="billingCity" value="${payload.details.billingAddress.city}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="billingState" value="${payload.details.billingAddress.state}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="billingZip" value="${payload.details.billingAddress.postalCode.split('-').join('')}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="shippingName" value="${payload.details.shippingAddress.recipientName}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="shippingAddress1" value="${payload.details.shippingAddress.line1}" />`).appendTo(shoppingCartForm);
				if (payload.details.shippingAddress.line2)
					$(`<input type="hidden" name="shippingAddress2" value="${payload.details.shippingAddress.line2}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="shippingCity" value="${payload.details.shippingAddress.city}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="shippingState" value="${payload.details.shippingAddress.state}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="shippingZip" value="${payload.details.shippingAddress.postalCode.split('-').join('')}" />`).appendTo(shoppingCartForm);
				$(`<input type="hidden" name="piAmount" value="${amount}" />`).appendTo(shoppingCartForm);
				shoppingCartForm.children('input[name="URL"]').val('OrderReviewCmd');
				shoppingCartForm.prop('action', 'PayPalExpressCheckout');
				//			console.log('ShippingAddress: ' + JSON.stringify(payload.details.shippingAddress));
				//			console.log('BillingAddress: ' + JSON.stringify(payload.details.billingAddress));
				//			console.log('updated nonce input field with: ' + payload.nonce);
				//			console.log("paypalCheckoutInstance.tokenizePayment: ", payload);
				shoppingCartForm.submit();
			};
		var pageType = 'cart';
		setupPaypalCheckout(expressCheckoutPaymentData, '#paypal-express-checkout-button-1', style, responseFunction, pageType);
		setupPaypalCheckout(expressCheckoutPaymentData, '#paypal-express-checkout-button-2', style, responseFunction);
	}
};

const setupPaypalPaymentPage = () => {
	if (
		$('#paypal-payment-button').length > 0 &&
		$('#orderReviewForm').length > 0 &&
		$('#creditCardForm input[name="piAmount"]').val().length > 0 &&
		Number($('#creditCardForm input[name="piAmount"]').val()) > 0
	) {
		var shippingAddressInput = $('#orderReviewForm input[name="shippingAddressId"]'),
			shippingAddressOverride = {},
			paymentData = {
				flow: 'checkout', // Required
				intent: 'order', // Required
				amount: $('#creditCardForm input[name="piAmount"]').val(),
				currency: 'USD', // Required
				shippingAddressEditable: false,
				offerCredit: false,
				locale: 'en_US',
				singleUse: true,
			},
			style = {
				layout: 'horizontal',
				color: 'silver',
				shape: 'rect',
				size: 'medium',
				label: 'checkout',
				height: 35,
				tagline: false,
			},
			responseFunction = function (payload) {
				$(`<input type="hidden" name="nonce" value="${payload.nonce}" />`).appendTo('#orderReviewForm');
				$(`<input type="hidden" name="billingFirstName" value="${payload.details.firstName}" />`).appendTo('#orderReviewForm');
				$(`<input type="hidden" name="billingLastName" value="${payload.details.lastName}" />`).appendTo('#orderReviewForm');
				$(`<input type="hidden" name="billingEmail" value="${payload.details.email}" />`).appendTo('#orderReviewForm');
				$(`<input type="hidden" name="billingPhone" value="${payload.details.phone.split('-').join('')}" />`).appendTo('#orderReviewForm');
				$(`<input type="hidden" name="billingAddress1" value="${payload.details.billingAddress.line1}" />`).appendTo('#orderReviewForm');
				$(`<input type="hidden" name="billingAddress2" value="${payload.details.billingAddress.line2}" />`).appendTo('#orderReviewForm');
				$(`<input type="hidden" name="billingCity" value="${payload.details.billingAddress.city}" />`).appendTo('#orderReviewForm');
				$(`<input type="hidden" name="billingState" value="${payload.details.billingAddress.state}" />`).appendTo('#orderReviewForm');
				$(`<input type="hidden" name="billingZip" value="${payload.details.billingAddress.postalCode.split('-').join('')}" />`).appendTo('#orderReviewForm');
				$(`<input type="hidden" name="isPayPal" value="true" />`).appendTo('#orderReviewForm');
				//add logic to clear current form here
				//				console.log('updated nonce input field with: ' + payload.nonce);
				//				console.log("BillingAddress: " + JSON.stringify(payload.details.billingAddress));
				//				console.log("paypalCheckoutInstance.tokenizePayment: ", payload);
				$('input[name="CardType2"]').attr('checked', false);
				$('#paypalRadio').attr('checked', true);
				$('#creditCardForm').submit();
			};
		//set up shipping address from our side and add it to PaymentData
		if (shippingAddressInput.length > 0 && shippingAddressInput.data('shipping-address1')) {
			if (shippingAddressInput.data('shipping-isRegistry') == 'false') {
				shippingAddressOverride.recipientName = shippingAddressInput.data('shipping-name');
				shippingAddressOverride.line1 = shippingAddressInput.data('shipping-address1');
				if (shippingAddressInput.data('shipping-address2')) shippingAddressOverride.line2 = shippingAddressInput.data('shipping-address2');
				shippingAddressOverride.city = shippingAddressInput.data('shipping-city');
				shippingAddressOverride.state = shippingAddressInput.data('shipping-state');
				shippingAddressOverride.postalCode = shippingAddressInput.data('shipping-zip');
				shippingAddressOverride.countryCode = 'US';
				shippingAddressOverride.editable = false;
				paymentData.shippingAddressOverride = shippingAddressOverride;
			}
		}

		//add our orderId to the PaymentData
		if ($('input[name="orderId"]').length > 0) paymentData.orderId = $('input[name="orderId"]').val();
		//display our shipping address Data in the paypal modal if there is only one address (to avoid confusion)
		if (
			shippingAddressInput.length > 0 &&
			shippingAddressInput.data('single-shipping-address') &&
			shippingAddressInput.data('shipping-isRegistry') == 'false'
		)
			paymentData.enableShippingAddress = shippingAddressInput.data('single-shipping-address');
		else paymentData.endableShippingAddress = false;

		//render the button with the options above
		var pageType = 'payment';
		setupPaypalCheckout(paymentData, '#paypal-payment-button', style, responseFunction, pageType);
	}
};

const setupPaypalCheckout = (checkoutPaymentData, paypalButtonPlaceHolder, style, responseFunction, pageType) => {
	var authorizationId = $(paypalButtonPlaceHolder).data('client-auth-id');
	try{
		braintree.client.create(
			{authorization: authorizationId},
			function (clientErr, clientInstance) {
				// Stop if there was a problem creating the client (network error/authorization invalid).
				if (clientErr) {
					var newHTML = '<div class="hidden paypal-error-tracking-client">Error creating braintree client:-' + clientErr + '</div>';
					$('#content-wrapper').append(newHTML);
					return;
				}
				// Create a PayPal Checkout component.
				braintree.paypalCheckout.create(
					{client: clientInstance},
					function (paypalCheckoutErr, paypalCheckoutInstance) {
						paypalCheckoutInstance.loadPayPalSDK({
							intent: checkoutPaymentData.intent,
							currency: checkoutPaymentData.currency,
							locale: checkoutPaymentData.locale,
						}, function () {
							paypal.Buttons({
								env: authorizationId.split('_')[0], // 'sandbox' or 'production'
								commit: false, // This will add the transaction amount to the PayPal button and change button text to "pay now"
								locale: 'en_US',
								style: style,
								funding: {
									allowed: [],
									disallowed: [paypal.FUNDING.CREDIT],
								},
								fundingSource: paypal.FUNDING.PAYPAL,
								createOrder: function () {
									return paypalCheckoutInstance.createPayment(checkoutPaymentData).catch(function (error) {
										if (
											error.details &&
											error.details.originalError &&
											error.details.originalError.details &&
											error.details.originalError.details.originalError &&
											error.details.originalError.details.originalError.paymentResource &&
											error.details.originalError.details.originalError.paymentResource.errorMessage &&
											error.details.originalError.details.originalError.paymentResource.errorMessage.indexOf('zip') > -1
										) {
											var shippingBreadcrumbURL = $('.order-nav li#one a').attr('href');
											if (shippingBreadcrumbURL.length > 0 && $('#paypal-payment-button').length > 0 && $('#step2Content').length > 0) {
												var displayError = `<div id="errors" class="alert alert-danger alert-dismissible" role="alert">
																<button id="error-message" class="alert-dismiss close" type="button" data-dismiss="alert">&times;</button>
																To continue checkout with PayPal, please <a href="${shippingBreadcrumbURL}">click here</a> to correct your shipping address. </div>`;
												$('#step2Content').prepend(displayError);
												$('#paypal-payment-button').hide();
												scrollTo('#step2Content');
											}
										}
										var newHTML = '<div class="hidden paypal-error-tracking-button-payment">Error after clicking paypal button:-' + error + '</div>';
										$('#content-wrapper').append(newHTML);
									});
								},
								onApprove: function (data, actions) {
									return paypalCheckoutInstance.tokenizePayment(data).then(responseFunction);
								},
								onError: function (err) {
									var newHTML = '<div class="hidden paypal-error-tracking-button-render">Error rendering the paypal button:-' + err + '</div>';
									$('#content-wrapper').append(newHTML);
								},
							}).render(paypalButtonPlaceHolder)
							  .then(function() {
								  $('#paypal-express-checkout-button-1,#paypal-express-checkout-button-2,.paypal-group').attr('style', '');
								  //consolel.log('Paypal has loaded')
							  })
						});
						// Stop if there was a problem creating PayPal Checkout. (network error/checkout config invalid).
						if (paypalCheckoutErr) {
							var newHTML = '<div class="hidden paypal-error-tracking-paypalCheckout">Error creating paypalCheckout:-' + paypalCheckoutErr + '</div>';
							$('#content-wrapper').append(newHTML);
							return;
						}
					}
				);
			}
		);
	} catch {
		var newHTML = '<div class="hidden paypal-error-tracking-client">Error creating braintree client:-</div>';
            $('#content-wrapper').append(newHTML);
	}
};
export { setupPaypalExpressCheckout, setupPaypalPaymentPage };
